import { Dispatch } from "../../config/controller";
import { Paciente } from "../../config/data.types";
import { Model,StateProps } from "../../config/model";

export type { Paciente } from "../../config/data.types";

export interface PacienteState extends StateProps<Paciente> {
 
}

export interface PacienteActions extends Dispatch<Paciente> {
    showModalSelectPaciente: () => any
}

const model = new Model<Paciente,PacienteState>("paciente");

export const initialValuePaciente:Paciente = {
    ...model.getInitialValue(),
    type:"paciente",
    nome:"",
    whatsapp:""

}

export const initialValuePacienteState:PacienteState = {
    ...model.getInititalValueState(),
    row:initialValuePaciente,   
}


